import React, { Component } from "react";
import { API, Storage } from "aws-amplify";
import NewLogin from "./NewLogin";
import NewSignup from "./NewSignup";
import CarouselWidget from "./CarouselWidget";
import CaseOfTheMonth from "./CaseOfTheMonth";
import ForgotPassword from "./ForgotPassword";
import RetnetRegister from "./RetnetRegister";
import RetnetRegister2020 from "./RetnetRegister2020";
import BookingDetails from "./BookingDetails";
import Booking1 from "./Booking1";
import SingleOccupancy from "./SingleOccupancy";
import DoubleOccupancy from "./DoubleOccupancy";
import TripleOccupancy from "./TripleOccupancy";
import SubmitPresentation from "./SubmitPresentation";
import "./RetnetRegister.css"
import RetnetLiveWebLink from "./RetnetLiveWebLink";
import PreConferenceRegistration from "./PreConferenceRegistration";


export default class Home extends Component {

  constructor(props){
    super(props);
    this.paynow = React.createRef();
    this.state = {

    }
  }



  async componentDidMount(){

    try{
        this.printTime("Before Loading");

        var caseOfTheMonth = await this.getCaseOfTheMonth();
        var attachments = [];
        var attachmentUrls = [];
        this.printTime("After COM : ");

        if(caseOfTheMonth.attachment){
          attachments = caseOfTheMonth.attachment.split(",");
          for(var i = 0 ; i < attachments.length; i++){
              attachmentUrls[i] = "https://retnetindiadev-blog-uploads.s3.amazonaws.com/public/"+attachments[i];
          }
        }

       var truncatedContent = caseOfTheMonth.content.length > 300
                               ? caseOfTheMonth.content.substring(0,300) + "... "
                               : caseOfTheMonth.content;

       var stats = await this.getStats();
       this.printTime("After Stats: ");

       this.setState({
          caseOfTheMonth: caseOfTheMonth,
          attachmentUrls: attachmentUrls,
          truncatedContent: truncatedContent,
          stats: stats,
          isLoading: false
       });
       this.props.updateCaseOfTheMonth(caseOfTheMonth);
       this.printTime("After Loading");


    }catch(e){
     this.setState( { isLoading: false } );
     alert(e);
    }
  }

  printTime(prefixStr){
      var currentdate = new Date();
      var datetime = "Last Sync: " + currentdate.getDay() + "/"+currentdate.getMonth()
      + "/" + currentdate.getFullYear() + " @ "
      + currentdate.getHours() + ":"
      + currentdate.getMinutes() + ":" + currentdate.getSeconds();
      console.log(prefixStr + " : " + datetime);
  }

  async getStats(){
    return await API.get("retnetindia", "/stats");
  }

  async getCaseOfTheMonth(){

    return await API.get("retnetindia", "/com");
  }



  renderForm(){
    if(this.props.location.pathname === "/signup"){
      return(
        <NewSignup userHasAuthenticated = {this.props.userHasAuthenticated}
                       history={this.props.history} />
      );
    }

    if(this.props.location.pathname === "/forgotpassword"){
      return(
         <ForgotPassword history={this.props.history}/>
      );
    }

    return(
      <NewLogin userHasAuthenticated = {this.props.userHasAuthenticated}
                     history={this.props.history} />
    );
  }

  renderUnAuthenticatedBlock(){
    if(this.props.location.pathname === "/register4retnet"){
      return(
          <RetnetRegister2020 history={this.props.history} />
      );
    }


      if(this.props.location.pathname === "/retnetlive"){
          return(
              <RetnetLiveWebLink history={this.props.history} />
          );
      }

      if(this.props.location.pathname === "/preconference"){
          return(
              <PreConferenceRegistration history={this.props.history} />
          )
      }

    if(this.props.location.pathname === "/conference"){
      return(
         <Booking1 history={this.props.history} />
      );
    }
    if(this.props.location.pathname === "/singleroom"){
      return(
         <SingleOccupancy nights={1} history={this.props.history} />
      );
    }
      if(this.props.location.pathname === "/singleroom2nights"){
          return(
              <SingleOccupancy nights={2} history={this.props.history} />
          );
      }
    if(this.props.location.pathname === "/doubleroom"){
      return(
         <DoubleOccupancy nights={1} history={this.props.history} />
      );
    }
      if(this.props.location.pathname === "/doubleroom2nights"){
          return(
              <DoubleOccupancy nights={2} history={this.props.history} />
          );
      }

    if(this.props.location.pathname === "/tripleroom"){
      return(
         <TripleOccupancy history={this.props.history} />
      );
    }

    if(this.props.location.pathname === "/submitpresentation"){
      return(
         <SubmitPresentation history={this.props.history} />
      );
    }

    if(this.props.location.pathname.includes("/bookingconfirmation") &&
        this.props.history.location.search.includes("payment_id=")){
      var txnId = "";
      var txnStatus = "";
      var tokens = this.props.history.location.search.split("=");

      if(tokens && tokens.length === 3){
        txnStatus = tokens[2];
        txnId = tokens[1].split("&")[0];
      }
      var regId = localStorage.getItem("registrationId");

      if(regId){
         localStorage.removeItem("registrationId");
         var paymentStatus = txnStatus == "success" ? "Paid" : "Not Paid";

         try{
           var registrationDetails = API.post("retnetindia", "/register4retnet", {
             body: {"registrationId": regId,
                     "paymentStatus": paymentStatus,
                      "txnId": txnId}
           });
         }catch(e){
           console.log(e.message);
         }

      }
    }


    return(
      <div>
      {
        this.props.location.pathname.includes("/bookingconfirmation")
                                      ?  <div class="alert alert-success retnet-center-text retnet-18-font-size" role="alert">
                                            Thank you for registering for our 12th Retnet Annual Meeting
                                          </div>
                                      : <div></div>
      }



      <div className="row">



          <div className="col-md-8">

                 <div id="carouselExampleControls" className="carousel slide  retnet-home-page-carousel" data-ride="carousel">
                      <div className="carousel-inner">

                          {/*<div className="carousel-item active">*/}
                          {/*    <img className="d-block w-100 retnet-home-carousel-img"  src="/images/retnet2023-preconference.jpeg" alt="First slide" />*/}
                          {/*</div>*/}

                          {/*<div className="carousel-item active">*/}
                          {/*    <img className="d-block w-100 retnet-home-carousel-img"  src="/images/retnet14flyer.jpeg" alt="First slide" />*/}
                          {/*</div>*/}

                          {/*<div className="carousel-item active">*/}
                          {/*    <img className="d-block w-100 retnet-home-carousel-img"  src="/images/retnet2024dateandvenue.jpeg" alt="First slide" />*/}
                          {/*</div>*/}
                          {/*<div className="carousel-item active">*/}
                          {/*    <a href="https://forms.gle/z77CyXfwLDX5UmtS6" target="_blank">*/}
                          {/*        <img className="d-block w-100 retnet-home-carousel-img"  src="/images/RegisterRetnetApChapter2026.png" alt="First slide" />*/}
                          {/*    </a>*/}
                          {/*</div>*/}
                          <div className="carousel-item active">
                              <img className="d-block w-100 retnet-home-carousel-img"  src="/images/Retnet2026_Registrations.jpeg" alt="Second slide" />
                          </div>
                          {/*<div className="carousel-item ">*/}
                          {/*    <img className="d-block w-100 retnet-home-carousel-img"  src="/images/retnet_ap_chapter_abstracts.jpeg" alt="Second slide" />*/}
                          {/*</div>*/}
                          {/*<div className="carousel-item">*/}
                          {/*    <img className="d-block w-100 retnet-home-carousel-img"  src="/images/retnet2022-streaming-msg.jpeg" alt="Second slide" />*/}
                          {/*</div>*/}

                          {/*<div className="carousel-item">*/}
                          {/*    <img className="d-block w-100 retnet-home-carousel-img" src="/images/retnet2024_online_streaming.jpeg" alt="Third slide" />*/}
                          {/*</div>*/}

                      </div>
                      <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span className="sr-only">Previous</span>
                      </a>
                      <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                          <span className="carousel-control-next-icon" aria-hidden="true"></span>
                          <span className="sr-only">Next</span>
                      </a>
                  </div>

              {/*<div className="text-center highlight-text" >*/}
              {/*    <a href="/retnetlive" className="btn btn-success text-uppercase btn-circle retnet-btn text" >Retnet 2023 Live Streaming Registration</a>*/}
              {/*</div>*/}

              {/*<img className="retnet-banner" src="/images/retnetbanner-2022-2.jpeg" height="300px" />*/}
              <br />
              {/*<div className="text-center red-font"> No Rooms At The Venue. Only Conference Registration Open.</div>*/}
              <div className="text-center">
                  {/*<a href="https://forms.gle/vn3uAvEVMoW962wU9" className="btn btn-success text-uppercase btn-circle retnet-btn text" >*/}
                  {/*    Submit Abstract*/}
                  {/*</a>*/}
                  {/*<a href="/retnet2023" className="btn btn-success text-uppercase btn-circle retnet-btn text" >*/}
                  {/*    View Retnet AP Schedule*/}
                  {/*</a>*/}

                  {/*<a href="/retnetlive" className="btn btn-success text-uppercase btn-circle retnet-btn text" >*/}
                  {/*    Watch Retnet Live*/}
                  {/*</a>*/}

                  <a href="https://forms.gle/q5MFbttc36EMQ4um8" target="_blank" className="btn btn-success text-uppercase btn-circle retnet-btn text" >
                      Register For Retnet
                  </a>

                  {/*<a href="/register4retnet" className="btn btn-success text-uppercase btn-circle retnet-btn text" >*/}
                  {/*    Register For Retnet*/}
                  {/*</a>*/}
              </div>
              {/*<div className="text-center red-font">*/}
              {/*    Submission Last Date : 12th April, 2025*/}

              {/*</div>*/}
              {/*<div className="text-center red-font">*/}
              {/*    Announcement of Acceptance :   14th May, 2025*/}

              {/*</div>*/}

            </div>
            <div className="col-md-4">

                <br />
                <br />

                { this.renderForm() }



            </div>
      </div>


     <br/>

      </div>
    );
  }


  renderAuthenticatedBlock(){
    if(this.props.location.pathname === "/register4retnet"){
      return(
          <RetnetRegister2020 history={this.props.history}  />

      );
    }

    if(this.props.location.pathname === "/retnetlive"){
          return(
              <RetnetLiveWebLink history={this.props.history} />
          );
    }
    if(this.props.location.pathname === "/conference"){
      return(
         <Booking1 history={this.props.history} />
      );
    }
    if(this.props.location.pathname === "/singleroom"){
      return(
         <SingleOccupancy history={this.props.history} />
      );
    }
    if(this.props.location.pathname === "/doubleroom"){
      return(
         <DoubleOccupancy history={this.props.history} />
      );
    }
    if(this.props.location.pathname === "/tripleroom"){
      return(
         <TripleOccupancy history={this.props.history} />
      );
    }

    if(this.props.location.pathname === "/submitpresentation"){
      return(
         <SubmitPresentation history={this.props.history} />
      );
    }


    if(this.props.location.pathname.includes("/bookingconfirmation") &&
        this.props.history.location.search.includes("payment_id=")){
      var txnId = "";
      var txnStatus = "";
      var tokens = this.props.history.location.search.split("=");

      if(tokens && tokens.length === 3){
        txnStatus = tokens[2];
        txnId = tokens[1].split("&")[0];
      }
      var regId = localStorage.getItem("registrationId");

      if(regId){
         localStorage.removeItem("registrationId");
         var paymentStatus = txnStatus == "success" ? "Paid" : "Not Paid";

         try{
           var registrationDetails = API.post("retnetindia", "/register4retnet", {
             body: {"registrationId": regId,
                     "paymentStatus": paymentStatus,
                      "txnId": txnId}
           });
         }catch(e){
           console.log(e.message);
         }

      }
    }

    return(
      <div>
          {
            this.props.location.pathname.includes("/bookingconfirmation")
                                          ?  <div class="alert alert-success retnet-center-text retnet-18-font-size" role="alert">
                                                Thank you for registering for our 12th Retnet Annual Meeting.
                                                If you registered to watch Retnet Live, Zoom Meeting Link will be sent to your email.
                                              </div>
                                          : <div></div>
          }


        <div className="row">



              <div className="col-md-2">
                  <div className="holder-item slice-lg">
                      <div className="container d-flex">
                          <div className="row cols-xs-space cols-sm-space text-center">

                              <div className="">
                                {/* <img className="retnet-banner" src="/images/2018/2.JPG" height="500px" /> */}


                              </div>
                          </div>

                      </div>
                  </div>
              </div>
              <div className="col-md-8" >

                  <div id="carouselExampleControls" className="carousel slide  retnet-home-page-carousel" data-ride="carousel">
                      <div className="carousel-inner">
                          <div className="carousel-item active">
                              <img className="d-block w-100 retnet-home-carousel-img"  src="/images/2018/2.JPG" alt="Second slide" />
                          </div>
                          <div className="carousel-item">
                              <img className="d-block w-100 retnet-home-carousel-img"  src="/images/2018/9.JPG" alt="Second slide" />
                          </div>
                          <div className="carousel-item">
                              <img className="d-block w-100 retnet-home-carousel-img" src="/images/2018/11.JPG" alt="Third slide" />
                          </div>

                      </div>
                      <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span className="sr-only">Previous</span>
                      </a>
                      <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                          <span className="carousel-control-next-icon" aria-hidden="true"></span>
                          <span className="sr-only">Next</span>
                      </a>
                  </div>
              </div>
              <div className="col-md-2"></div>


        </div>

         <br />
      </div>
      );

  }

  renderStats(){
    return(
      <div className="row ">
            <div className="col-lg-4 col-md-8">
                <div className="milestone-counter text-center">
                    <div className="milestone-count strong-600 visible full-visible" data-from="0" data-to="5518" data-speed="3000" data-refresh-interval="100">
                      {this.state.stats.doctors}
                   </div>
                    <h4 className="milestone-info heading-3 text-normal">Doctors</h4>
                </div>
            </div>
            <div className="col-lg-4 col-md-8">
                <div className="milestone-counter text-center">
                    <div className="milestone-count strong-600 visible full-visible" data-from="0" data-to="154" data-speed="5000" data-refresh-interval="50">
                       {this.state.stats.blogs}
                    </div>
                    <h4 className="milestone-info heading-3 text-normal">Blogs</h4>
                </div>
            </div>
            <div className="col-lg-4 col-md-8">
                <div className="milestone-counter text-center">
                    <div className="milestone-count strong-600 visible full-visible" data-from="0" data-to="33" data-speed="5000" data-refresh-interval="80">
                      {this.state.stats.comments}
                    </div>
                    <h4 className="milestone-info heading-3 text-normal">Comments</h4>
                </div>
            </div>

        </div>
    );
  }


  render(){
    return(
      <div>
        <div className="container retnet-home-banner">
        { this.props.isAuthenticated
              ? this.renderAuthenticatedBlock()
              : this.renderUnAuthenticatedBlock()
        }

        </div>

        <section className="cta-wrapper">

                      <div className="slice cta-inner bg-base-1">
                          <div className="flex flex-items-xs-middle">
                              <div className="flex-wrap-item">
                                  <div className="sct-inner ">
                                      <div className="container">
                                          <div className="text-center">
                                              <h1 className="heading heading-3 text-normal c-base-text-1 strong-400">
                                                {
                                                  this.state.caseOfTheMonth
                                                      ?
                                                          <span className="retnet-yrsa-font"> CASE OF THE MONTH BY {this.state.caseOfTheMonth.author}</span>


                                                      : <span className="retnet-yrsa-font"> CASE OF THE MONTH - Loading <i className="fa fa-refresh fa-spin fa-2x"></i>  </span>
                                                }

                                              </h1>
                                              {
                                                this.state.caseOfTheMonth
                                                    ? <div>
                                                        <h1 className="retnet-yrsa-font">"{this.state.caseOfTheMonth.title}"</h1>

                                                      </div>
                                                    : <p></p>
                                              }

                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>

        </section>



        <section className="slice-lg ">
              <div className="container">
                  <div className="row cols-xs-space cols-sm-space cols-md-space align-items-center">
                      <div className="col-md-6">
                        {
                          this.state.caseOfTheMonth
                                ? <CarouselWidget  blog={this.state.caseOfTheMonth} blogimages={this.state.attachmentUrls}/>
                                : <span>Loading <i className="fa fa-refresh fa-spin fa-2x"></i> </span>
                        }
                      </div>

                      <div className="col-md-6 col-lg-6">
                          <div className="col-lg-space-left">
                              <h3 className="heading heading-2 strong-500">
                              {
                                this.state.caseOfTheMonth
                                      ? this.state.caseOfTheMonth.title
                                      : <span></span>
                              }
                              </h3>

                              {
                                this.state.caseOfTheMonth
                                      ?   <p className="line-height-1_8 c-gray-light mt-4 retnet-home-desc">
                                            {this.state.truncatedContent}  <br />

                                             { this.props.isAuthenticated
                                                  ? <a href="/blogs">Read Blogs for more details</a>
                                                  : <span className="pull-right ">
                                                        <mark>
                                                          --Login to see the complete blog with comments
                                                       </mark>
                                                     </span>


                                             }


                                          </p>
                                      : <span></span>
                              }
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <br />
          <br />

          <div className="container-fluid bg-base-1">
              {
                this.state.stats
                   ? this.renderStats()
                   : <span className="text-center"> Loading <i className="fa fa-refresh fa-spin fa-2x"></i> </span>
              }


          </div>

      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js